export default[
    {
        path: '/32ncLKV9gDJx',
        children : [
            {
                path: '6UNPrPEv9EBI',
                name: 'migrate-students',
                meta: {
                    title: 'Migrate Students',
                    authRequired: true,
                    acc: null
                },
                component: ()=> import('@/views/migration/index.vue')
            },
            {
                path: 'ypcwRJYFZOiT',
                name: 'graduate-students',
                meta: {
                    title: 'Graduate Students',
                    authRequired: true,
                    acc: null
                },
                component: ()=> import('@/views/migration/graduate.vue')
            },

            // level migration
            {
                path: '6UNPrPEv9EBIWQ',
                name: 'migrate-students-l',
                meta: {
                    title: 'Migrate Students',
                    authRequired: true,
                    acc: null
                },
                component: ()=> import('@/views/level/students/transfer.vue')
            },
        
        ]



    }

]